import classNames from "classnames";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { FloatLabel } from "primereact/floatlabel";
import { InputNumber } from "primereact/inputnumber";
import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FaPencil, FaTrash } from "react-icons/fa6";
import { toast } from "react-toastify";
import { useInfo } from "../../../../context/infoContext";
import { Api } from "../../../../services/api";
import { FloatLabelNumber, InputNumberPague } from "../../../../styles/primeReactConfig";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { valueValidation } from "../../../../utils/validacoes";
import { confirmFooter } from "../../../confirmFooter";


function UpdateDeleteParcela({ close, infoParam, reload, create }) {
  const { infoParcelamento } = useInfo()
  const [valorInicial, setValorInicial] = useState();
  const [valorFinal, setValorFinal] = useState()
  const [numeroMaxParcelas, setNumeroMaxParcelas] = useState();

  const CreateValores = async () => {
    if (valorInicial && valorFinal && numeroMaxParcelas) {
      const ppp_valor_inicial = valorInicial;
      const ppp_valor_final = valorFinal;
      const ppp_numero_parcelas = numeroMaxParcelas;
      try {
        await Api.post('parametrosproviderparcelas/insere', { ppp_numero_parcelas, ppp_valor_inicial, ppp_valor_final, ppp_status: 'A' })
        toast.success("Faixa de valor adicionada com sucesso");
        close();
        reload()
      } catch (err) {
        console.log(err)
        toast.error("Erro ao adicionar faixa de valor")
      }
    }
    else toast.warning("Preencha todos os campos")
  }

  const UpdateValores = async () => {
    const ppp_numero_parcelas = numeroMaxParcelas;
    const ppp_valor_inicial = valorInicial;
    const ppp_valor_final = valorFinal;
    const ppp_id = infoParam.ppp_id;
    toast.info('Atualizando parâmetro...')
    try {
      await Api.put(`/parametrosproviderparcelas/atualiza`, { ppp_numero_parcelas, ppp_valor_final, ppp_valor_inicial, ppp_id });
      toast.success('Parâmetro atualizado com sucesso');
      close();
      reload();
    } catch (err) {
      toast.error('Erro ao atualizar parâmetro de parcelamento');
      console.log(err);
    }
  }

  const DeleteValores = async () => {
    const ppp_id = infoParam.ppp_id;
    toast.info('Deletando parâmetro...')
    try {
      await Api.delete(`parametrosproviderparcelas/deleta/${ppp_id}`);
      toast.success('Parâmetro deletado com sucesso');
      close();
      reload();
    } catch (err) {
      toast.error('Erro ao deletar parâmetro de parcelamento');
      console.log(err);
    }
  }

  const validateParcela = () => {
    if (create) {
      const minimo = valueValidation(infoParcelamento, 'ppp_valor_final')
      return (Number(minimo) + 0.01)
    }
    else return 0
  }

  const UpdateFooter = () => {

    if (!create)
      return (<>
        <Button
          label="Deletar"
          icon={<FaTrash />}
          severity="danger"
          onClick={DeleteConfirm}
        />
        <Button
          label="Atualizar"
          icon={<FaPencil />}
          severity="success"
          onClick={UpdateValores}
        />
      </>)
    else
      return (<>
        <Button
          label="Adicionar"
          icon={<FaPlus />}
          severity="info"
          onClick={CreateValores}
        />
      </>)
  }

  const DeleteConfirm = () => {
    confirmDialog({
      message: 'Deseja deletar o parametro de desconto selecionado?',
      header: 'Deletar',
      acceptClassName: "outline-green-500 hover:outline-green-600 outline-2 outline bg-green-500 hover:bg-green-600 rounded-md w-full py-3 text-white transition duration-150",
      rejectClassName: "outline-red-500 outline-2 outline rounded-md w-full py-3 text-red-500 hover:bg-red-500 hover:text-white transition duration-150",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => DeleteValores(),
      footer: (e) => confirmFooter(e),
    });
  }

  return (
    <>
      <ConfirmDialog />
      
      <Dialog
        visible
        header={!create ? "Deletar/Atualizar faixa de valor" : "Adicionar faixa de valor"}
        footer={UpdateFooter}
        onHide={() => close()}
        pt={{
          root: ({ state }) => ({
            className: classNames('rounded-lg shadow-lg border-0',
              'transform scale-100',
              'flex flex-col lg:w-[65vw] md:w-[75vw] sm:w-[85vw] w-[95vw] max-h-[95vh] ',
              'm-0 z-50 pointer-events-auto',
              'ml-2 mb-2',
              'overflow-hidden',
              'dark:border dark:border-blue-900/40', {
              'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized,
            })
          }),
          content: ({ state }) => ({
            className: classNames('h-full overflow-auto',
              'bg-white text-gray-700 px-6 pb-8 pt-0',
              //'rounded-bl-lg rounded-br-lg', 
              'dark:bg-gray-900  dark:text-white/80 ', {
              grow: state.maximized
            })
          }),
          footer: {
            className: classNames('shrink-0 flex flex-row justify-end gap-4',
              'relative z-50 pointer-events-auto',
              'border-t-0 bg-white text-gray-700 px-6 pb-6 text-right rounded-b-lg',
              'dark:bg-gray-900 dark:text-white/80')
          },
        }}
      >
        <div className="md:flex grid p-4" style={{ marginTop: "5px" }}>
          <div className="grid w-full md:w-1/3 gap-7 p-3">
            <label htmlFor="valor_inicial" className="text-lg font-semibold">
              Valor Inicial
            </label>
            <FloatLabel pt={FloatLabelNumber} >
              <InputNumber
                currencyDisplay="symbol"
                currency="BRL"
                min={validateParcela()}
                value={valorInicial}
                pt={InputNumberPague}
                required
                mode="currency"
                id="valor_inicial"
                locale="pt-BR"
                onValueChange={(e) => setValorInicial(e.value)} />
              {create ? (<label htmlFor="valor_inicial">Valor inicial da faixa de valor</label>) :
                (<label htmlFor="valor_inicial">Valor Atual: {formatCurrency(infoParam.ppp_valor_inicial)}</label>)}
            </FloatLabel>
          </div>
          <div className="grid w-full md:w-1/3 gap-7 p-3">
            <label htmlFor="valor_final">Valor Final</label>
            <FloatLabel pt={FloatLabelNumber} >
              <InputNumber
                currencyDisplay="symbol"
                currency="BRL"
                min={valorInicial + 1}
                value={valorFinal}
                pt={InputNumberPague}
                required
                mode="currency"
                id="valor_final"
                locale="pt-BR"
                onValueChange={(e) => setValorFinal(e.value)} />
              {create ? (<label htmlFor="valor_final">Valor final da faixa de valor</label>) :
                (<label htmlFor="valor_final">Valor Atual: {formatCurrency(infoParam.ppp_valor_final)}</label>)}
            </FloatLabel>
          </div>
          <div className="grid w-full md:w-1/3 gap-7 p-3">
            <label htmlFor="numero_parcelas">Nº Max de Parcelas</label>
            <FloatLabel pt={FloatLabelNumber} >
              <InputNumber
                id="numero_parcelas"
                value={numeroMaxParcelas}
                pt={InputNumberPague}
                required
                min={0}
                max={100}
                suffix="x"
                onChange={(e) => setNumeroMaxParcelas(e.value)} />
              {create ? (<label htmlFor="numero_parcelas">Número máximo de parcelas</label>) :
                <label htmlFor="numero_parcelas">Número Atual: {infoParam.ppp_numero_parcelas}</label>}
            </FloatLabel>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default UpdateDeleteParcela